"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTaskQueue;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _pDeferEs = _interopRequireDefault(require("p-defer-es5"));

function createTaskQueue() {
  var queueWithCurrent = [];
  var queue = {
    cancelAll: function cancelAll() {
      queueWithCurrent.forEach(function (_ref) {
        var cancel = _ref.cancel;
        return cancel();
      });
    },
    push: function push(fn) {
      var cancelDeferred = (0, _pDeferEs.default)();
      var resultDeferred = (0, _pDeferEs.default)();
      var entry = {
        promise: resultDeferred.promise
      };
      var abort;

      var cancel = entry.cancel = function () {
        // Override the "fn" so we don't call the actual "fn" later.
        // In this approach, we can reuse the logic inside "start" to handle post-cancellation.
        fn = function fn() {
          return {
            result: Promise.reject(new Error('cancelled before start'))
          };
        }; // Abort the task if it is currently running.


        abort && abort();
        cancelDeferred.reject(new Error('cancelled in the midway'));
      };

      var start = /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
          var _fn, abortFn, result;

          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _fn = fn(), abortFn = _fn.abort, result = _fn.result;
                  abort = abortFn;
                  _context.prev = 2;
                  _context.t0 = resultDeferred;
                  _context.next = 6;
                  return Promise.race([result, cancelDeferred.promise]);

                case 6:
                  _context.t1 = _context.sent;

                  _context.t0.resolve.call(_context.t0, _context.t1);

                  _context.next = 13;
                  break;

                case 10:
                  _context.prev = 10;
                  _context.t2 = _context["catch"](2);
                  resultDeferred.reject(_context.t2);

                case 13:
                  queueWithCurrent = queueWithCurrent.filter(function (e) {
                    return e !== entry;
                  });

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[2, 10]]);
        }));

        return function start() {
          return _ref2.apply(this, arguments);
        };
      }();

      var lastEntry = queueWithCurrent[queueWithCurrent.length - 1];
      var lastPromise = lastEntry && lastEntry.promise || Promise.resolve();
      queueWithCurrent.push(entry); // After the last promise resolved/rejected, we will start this task.
      // We will start even if the last promise rejected.

      lastPromise.then(start, start);
      return {
        cancel: cancel,
        result: resultDeferred.promise
      };
    }
  };
  Object.defineProperty(queue, 'length', {
    get: function get() {
      return queueWithCurrent.length;
    }
  });
  return queue;
}